import React from "react";
import { Link } from "react-router-dom";

const PromotionalTwo = () => {
  return (
    <section className="promotional-banner">
      <div className="container container-lg">
        <div className="row gy-4 align-items-center">
          <div className="col-sm-6" style={{ padding: "50px" }}>
            <h4 className="text-dark myhh4">
              Best Printers for <span style={{ color: "#3446b8" }}>Home</span> &
              Office
            </h4>
            <p className="text-dark" style={{ fontSize: "18px" }}>
              Discover the ultimate printing solutions designed to make your
              home and office life easier. Whether you’re printing family
              photos, school projects, invoices, or business presentations — HP
              printers deliver unmatched quality, speed, and reliability.
            </p>
            <p className="text-dark" style={{ fontSize: "18px" }}>
              Choose from compact wireless home printers that fit perfectly in
              any space, to high-performance office models built for heavy
              workloads. Enjoy seamless connectivity with Wi-Fi and Bluetooth,
              smart ink technology that saves costs, and eco-friendly printing
              options that care for the planet.
            </p>

            <div className="flex">
              <Link
                to="/home-printers"
                className="btn btn-outline-white d-inline-flex align-items-center blue-btn gap-8 mt-20"
                style={{
                  background: "white",
                }}
              >
                Shop Home Printers
                <span className="icon text-xl d-flex">
                  <i className="ph ph-shopping-cart-simple" />
                </span>
              </Link>
            </div>
          </div>
          <div className="col-sm-6" style={{ padding: "50px" }}>
            <div className="">
              <img
                className="img-fluid rounded-8"
                src="assets/images/thumbs/about.jpg"
                alt="image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromotionalTwo;
